import React, { useState } from 'react';
import "./marketingSubscription.scss";
function MarketingSubscription() {
  const [email, setEmail] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
	  fetch("http://www.saxo.com/dk/permissionsexternal/setpermissionbyemail", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        email: email,
        permissionAliases: "saxo_main_permission",
        approve: true
      })
    })
    .then(function(response) {
	  // console.log("Response:", response);
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .then(function(data) {
      setSuccessMessage("Permission granted successfully!");
      setErrorMessage('');
      console.log("Success:", data);
    })
    .catch(function(error) {
      setErrorMessage("Error: " + error.message);
      setSuccessMessage('');
      console.error("Error:", error);
    });
  };

  return (
    <div className="marketing-form">
      <p className="marketing-form-title">Boginspiration</p>
      <form onSubmit={handleSubmit} className="icon icon-email">
        <input
          className="input-rounded"
          placeholder="Indtast din e-mail"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />

        <button type="submit" className="btn btn--red">Tilmeld dig</button>
      </form>
      {successMessage && <p>{successMessage}</p>}
      {errorMessage && <p>{errorMessage}</p>}
      <p>Jeg giver samtykke til, at Saxo.com må kontakte og målrette markedsføring til mig pr. brev og elektronisk (e-mail, sms/mms, push-beskeder, Facebook, Instagram, Pinterest, Google, LinkedIn, YouTube og addressable TV) vedrørende nyheder, anbefalinger, events, konkurrencer og tilbud på Saxos produktsortiment. Saxo må behandle mine personlige oplysninger som beskrevet i <a href="https://support.saxo.com/hc/da/articles/360000577349-PERSONDATAPOLITIK" target="_blank" className="link link--white">Saxos persondatapolitik</a>, herunder i relation til nævnte kommunikations- og medietjenester.<br/><br/>Jeg kan til enhver tid trække samtykket tilbage via Mit Saxo på Saxo.com, via afmeld-linket i Saxos nyhedsbreve eller ved at kontakte kundeservice.</p>
      
    </div>
  );
}

export default MarketingSubscription;